import { Component, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { getCurrentUserIsSystemUser } from 'src/app/authentication/state/authentication.selector';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { DeviceRegister } from '../../device-register';
import { DevicesFilterOption } from '../../models/device-filter-option';
import { DeviceRegisterListItem } from '../../models/device-register-results.model';
import { changeSipUserPasswords, rebootPhone, resetPhoneZtp } from '../../state/device-register.actions';
import * as DeviceDetailActions from 'src/app/pages/device-details/state/device-detail.actions';
import { DeviceDetailSaveEvent } from 'src/app/pages/device-details/models/device-detail-form-submit-event';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-device-register',
    templateUrl: './account-device-register.component.html',
    standalone: false
})
export class AccountDeviceRegisterComponent extends DeviceRegister {
   constructor(public store: Store) {
      super(store);
      this.isSystemUser$ = this.store.pipe(select(getCurrentUserIsSystemUser));
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: DevicesFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
      this.columns = [
         'account',
         'deviceModel',
         'extension',
         'macAddress',
         'sipUser',
         'lastDateProvisioned',
         'defaultPhoneNumber',
         'ztpRegistered',
         'connectionStatus',
         'lastConnected',
         'devicesActionsMenu',
      ];
   }

   onResetHackedAndFraud(device: DeviceRegisterListItem) {
      const hackedAndFraudSipUserIds = device.hackedAndFraudSipUserIds;

      if (
         hackedAndFraudSipUserIds !== null &&
         hackedAndFraudSipUserIds !== undefined &&
         hackedAndFraudSipUserIds.length > 0
      ) {
         this.store.dispatch(changeSipUserPasswords({ sipUserIds: hackedAndFraudSipUserIds }));
      }
   }

   onRebootPhone(deviceId: number) {
      this.store.dispatch(rebootPhone({ deviceId: deviceId }));
   }

   onResetPhoneZtp(deviceId: number) {
      this.store.dispatch(resetPhoneZtp({ deviceId: deviceId }));
   }

   onHideUsedDevicesChange(hideUsedDevices: boolean) {
      if (hideUsedDevices) {
         this.columns = [
            'account',
            'deviceModel',
            'macAddress',
            'sipUser',
            'lastDateProvisioned',
            'defaultPhoneNumber',
            'ztpRegistered',
            'connectionStatus',
            'lastConnected',
            'devicesActionsMenu',
         ];
      } else {
         this.columns = [
            'account',
            'deviceModel',
            'extension',
            'macAddress',
            'sipUser',
            'lastDateProvisioned',
            'defaultPhoneNumber',
            'ztpRegistered',
            'connectionStatus',
            'lastConnected',
            'devicesActionsMenu',
         ];
      }
   }
   onDeviceReleasedToSystem(event: DeviceDetailSaveEvent): void {
         this.store.dispatch(DeviceDetailActions.releaseDeviceDetail(event));
      }

   onReleaseToAccount(device: DeviceRegisterListItem): void {
      if (device.deviceId) {
         this.store.dispatch(
            DeviceDetailActions.releaseDeviceToAccount({ deviceId: device.deviceId })
         );
      }
   }

   onDeleteDevice(event: { deviceId: number }) {
         this.store.dispatch(DeviceDetailActions.deleteDevice(event));
      }
}
